export default __webpack_public_path__ + "static/media/a_wdt_c_0.baeb63b2.mp3";